<template>
  <div style="margin-top:5px;">
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer i18n-drop-down">
      <span class="cursor-pointer flex items-center i18n-locale">
        <img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
        <span class="sm:block ml-2">{{ getCurrentLocaleData.lang }}</span>
      </span>
      <vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
        <vs-dropdown-item @click="updateLocale('en')"><img class="h-4 w-5 mr-1" :src="basicUrl + 'en.png'" alt="en" /><span class="ml-1">English</span></vs-dropdown-item>
        <vs-dropdown-item @click="updateLocale('it')"><img class="h-4 w-5 mr-1" :src="basicUrl + 'it.png'" alt="it" /><span class="ml-1">Italian</span></vs-dropdown-item>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>
<style scoped>
.i18n-drop-down{
  margin-right: 15px;
}
</style>
<script>
import { getCountryName, setLocale } from '@/utils/auth'
import { getBackendUrl } from '@/utils/stripe'

export default {
  computed: {
    i18n_locale_img () {
         var flag = this.$i18n.locale == 'mr' ? 'in' : this.$i18n.locale;
         try {
           return this.basicUrl + flag + '.png';
         } catch {
           return '';
         }
    },
    getCurrentLocaleData () {
      const locale = this.$i18n.locale
      if (locale === 'en')      return { flag: 'en', lang: 'English' }
      else if (locale === 'it') return { flag: 'it', lang: 'Italian' }
      else return { flag: locale , lang: getCountryName(locale) }
    }
  },
  data() {
    return {
      basicUrl : getBackendUrl()
    }
  },
  methods: {
    updateLocale (locale) {
      this.$i18n.locale = locale;
      setLocale(locale);
    }
  }
}
</script>
